import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { FicheDePrep } from '@teetsh/app/src/types/sequences';
import { SEQUENCES_LIST_KEY } from '@teetsh/app/src/queries/sequences/useSequencesFolders';
import { AxiosError } from 'axios';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useLimitReached } from '@teetsh/app/src/components/LimitReached/useLimitReached';
import { useTranslation } from 'react-i18next';
import { SEQUENCE_KEY } from 'queries/sequences/useSequence';

export function useDuplicateStandaloneFicheDePrep() {
  const queryClient = useQueryClient();
  const { notifyError } = useNotification();
  const { openLimitModal } = useLimitReached();
  const { t } = useTranslation(['sequence']);
  return useMutation<
    FicheDePrep,
    AxiosError,
    {
      ficheDePrepId: string;
      folderId?: string;
    }
  >({
    mutationFn: ({ ficheDePrepId, folderId }) =>
      request(`/fiches-de-prep/${ficheDePrepId}/duplicate`, {
        method: 'POST',
        body: folderId ? { folderId } : undefined,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SEQUENCE_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [SEQUENCES_LIST_KEY],
      });
    },
    onError: err => {
      if (err?.response?.status === 403) {
        openLimitModal({
          requiredPlan: (err?.response as any)?.data?.requiredPlan,
          limit: (err?.response as any)?.data?.limit,
        });
        return;
      }
      notifyError({
        title: t('sequence:messages.seance.createError'),
      });
    },
  });
}
